<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca42"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('WithdrawalsRecordTwo_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('withdrawalsRecordTwo_statusQuery_button')"
          @click="updateWithdraw()"
          >更新提现结果</el-button
        >
        <el-button
          v-if="getLimit('WithdrawalsRecordTwo_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="accountId"
          title="提现商户号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.accountId"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cardNumber"
          title="银行卡号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.cardNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="transferAmount"
          title="提现金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.transferAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.transferAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="memo" title="备注" min-width="190" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.memo" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="提现状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'status')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 审核状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="auditMethod"
          title="审核状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'auditMethod')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.auditMethod"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.auditMethodOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 审核人员 -->
      <vxe-table-column>
        <vxe-table-column
          field="auditor"
          title="审核人员"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.auditor"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="withdrawApplyDate"
          title="提现时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.withdrawApplyDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'withdrawApplyDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="withdrawFinishDate"
          title="审核完成时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.withdrawFinishDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'withdrawFinishDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyName"
          title="提现人姓名"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.partyName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyPhone"
          title="提现人手机号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.partyPhone"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorDesc"
          title="错误描述"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorDesc"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          title="用户类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'partyType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.partyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="rejectReason"
          title="驳回原因"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.rejectReason"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="bizOrderNo"
          title="提现流水号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bizOrderNo"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              scope.row.status == 'WAIT_AUDIT' &&
                getLimit('withdrawalsRecordTwo_statusQuery_button')
            "
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="WithdrawalClick(scope.row.code)">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('withdrawalsRecordTwo_updateWithdraw_button') &&
                (scope.row.status == 'DEALING' || scope.row.status == 'SUCCESS')
            "
            class="item"
            effect="dark"
            content="更新提现结果"
            placement="top"
          >
            <vxe-button type="text" @click="updateWithdraw(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <el-drawer
      ref="drawer"
      title="审核页面"
      :visible.sync="dialog"
      direction="rtl"
      custom-class="demo-drawer"
      size="30%"
    >
      <div class="demo-drawer__content" style="margin-right:20px;width:95%">
        <el-form :model="form">
          <el-form-item label label-width="80px">
            <el-input
              v-model="form.rejectReason"
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div style="text-align:center">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="ToExamine('AUDITED')"
            >通过</el-button
          >
          <el-button
            type="primary"
            :loading="loading"
            @click="ToExamine('REJECT')"
            >驳回</el-button
          >
        </div>
      </div>
    </el-drawer>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import {
  getArpaWithdraw,
  arpaWithdraw,
  updateWithdraw
} from "@/api/InternetBanking";

export default {
  data() {
    return {
      loading: false,
      dialog: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/arpaWithdraw/exportArpaWithdrawList", //导出接口
        name: "提现记录"
      },
      tableData: [],
      parentData: {},
      form: {
        rejectReason: ""
      },
      emptyForm: {},
      listQuery: {
        withdrawApplyDateRange: "",
        gmtCreatedRange: "",
        withdrawFinishDateRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      auditMethod: "0"
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.status = "WAIT_AUDIT";
      } else {
        this.listQuery.status = "";
      }
      this.findList();
    }
  },
  created() {
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.status = "WAIT_AUDIT";
    }
    // 字段未确认
    this.parentData.partyTypeOptions = [
      {
        value: "DRIVER",
        label: "实际承运人"
      },
      {
        value: "SHIPMENT",
        label: "个体托运人"
      },
      {
        value: "DRIVER_LEADER",
        label: "车队长"
      },
      {
        value: "SHIPMENT_COMPANY",
        label: "企业托运人"
      },
      { label: "平台管理员", value: "PLAT_ADMIN" }
    ];
    this.parentData.statusOptions = [
      { value: "SUCCESS", label: "成功" },
      { value: "FAIL", label: "失败" },
      { value: "DEALING", label: "处理中" },
      { value: "WAIT_AUDIT", label: "待审核" },
      { value: "REJECT", label: "驳回" }
    ];
    this.parentData.auditMethodOptions = [
      { value: 0, label: "自动" },
      { value: 1, label: "人工" }
    ];
    this.initQuery = JSON.stringify(this.listQuery);
    this.findList();
  },
  methods: {
    async findList() {
      await this.getTableDataList(getArpaWithdraw);
    },
    //支付状态查询
    updateWithdraw(item) {
      let selectRecords = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (selectRecords.length == 0) {
        this.$message({
          message: "请选择要更新的条目",
          type: "warning"
        });
      } else {
        let filterReportedRecords = selectRecords.filter(
          item => item.status == "DEALING" || item.status == "SUCCESS"
        );
        let codes = filterReportedRecords.map(item => item.code).join(",");
        this.$refs.xTable.clearCheckboxRow();
        updateWithdraw({ codes }).then(response => {
          this.$message({
            message: response.msg,
            type: "success"
          });
          this.findList();
        });
      }
    },

    //审核
    WithdrawalClick(c) {
      this.dialog = true;
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.form.code = c;
    },
    ToExamine(a) {
      this.form.status = a;
      if (a == "REJECT") {
        if (this.form.errorDesc == "") {
          this.$message({
            message: "请输入驳回原因",
            type: "warning"
          });
          return false;
        }
      }
      arpaWithdraw(this.form).then(response => {
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.dialog = false;
        this.findList();
      });
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
::v-deep.el-dialog {
  margin: 0 auto !important;
  height: 60%;
  width: 32%;
  overflow: hidden;
}
::v-deep .el-dialog .el-dialog__body {
  position: absolute;
  left: 10px;
  top: 58px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
</style>
